module.exports = __webpack_public_path__ + "img/pic4_1.6c557b59.png";